import { Schema, TextField, ObjectField } from "lego-gui-lib";
import { createContext } from "react";
import { t } from "../../../core/i18n/i18n";
import { api, mainStore } from "../../../core/mainStore";
import { OutputType } from "../treeBlock/treeBlockOutputsDataSource";
import { ConnectionDataSource } from "./ConnectionDataSource";

export const FromSchema = new Schema({
  fields: [
    {
      title: "blockRef",
      name: "blockRef",
      type: TextField()
    },
    {
      title: "output",
      name: "output",
      type: TextField()
    }
  ],
  primaryKey: ["name"],
  security: { readableRole: "ADMIN", editableRole: "ADMIN" }
});

export const ToSchema = new Schema({
  fields: [
    {
      title: "blockRef",
      name: "blockRef",
      type: TextField()
    }
  ],
  primaryKey: ["name"],
  security: { readableRole: "ADMIN", editableRole: "ADMIN" }
});

export const ConnectionSchema = new Schema({
  primaryKey: ["id"],
  context: { auth: mainStore.auth },
  security: { readableRole: "ADMIN", editableRole: "ADMIN" },
  fields: [
    {
      name: "from",
      type: ObjectField(FromSchema),
      title: t("hns:tree:connection:from")
    },
    {
      name: "to",
      type: ObjectField(ToSchema),
      title: t("hns:tree:connection:to")
    }
  ]
});

mainStore.connection = new ConnectionDataSource({
  parent: mainStore.tree.oneDataSource,
  api: api,
  name: "connection",
  schema: ConnectionSchema,
  url: "/blocks/connections",
  commons: mainStore.commons
});

export const connectionContext = createContext(mainStore.connection);

export interface ConnectionDef {
  id?: number;
  type: OutputType;
  from: {
    blockRef: number;
    output: string;
  };
  to: {
    blockRef: number;
  };
}
